import { render } from "./SkuAttributes.vue?vue&type=template&id=626661ee"
import script from "./SkuAttributes.vue?vue&type=script&lang=js"
export * from "./SkuAttributes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__